import React, { Component } from "react";
import _ from "lodash";
import { Card, CardBody, CardHeader } from "reactstrap";
import Fade from "react-reveal/Fade";
import { Input } from "reactstrap";
import Loader from "../../../../Global/Loader";
import { Button } from "reactstrap";
import Table from "../../../Components/Table";
import axios from "axios";
import { Services } from "../../../../../repositories/clients/Services";
import { Dropdown } from "semantic-ui-react";
import { Modal, message } from "antd";
import { withRouter } from "react-router-dom";
import TemplateForm from "./../../Forms/template";
import ContainerWrapper from "../../../../template/Layout/ContentWrapper";
import "./styles/styles.scss";
const { confirm } = Modal;
const tableEntityConf = [
  { label: "ID", key: "EntityId" },
  { label: "Nombre Organización", key: "Name" },
  { label: "Código Organización", key: "Code" },
  { label: "Teléfono", key: "Telephone" },
  { label: "Pais", key: "Country" },
];

const tableBranchConf = [
  { label: "Branch Code", key: "BranchCode" },
  { label: "Nombre Branch", key: "BranchName" },
];
class MyProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rolOperative: false,
      data: {},
      loaderNotify: false,
      TemplateForm,
      isEdit: false,
      createFormData: "",
      generalInfo: "",
      idUsuario: this.props.match ? this.props.match.params.id : -1,
      userInfo: {
        ConfirmPassword: "",
        Email: "",
        LastName: "",
        Name: "",
        Password: "",
        Position: "",
        RolId: "",
        Telephone: "",
      },
      unEditedInfo: {},
      selectCatalog: [],
      camposUsuario: true,
      camposValidos: false,
      guardarDisabled: true,
      confirmPassError: false,
      loadingInfo: true,
      isEditing: false,
      tablaClientes: "",
      tablaBranch: "",
    };
  }

  componentDidMount = async () => {
    // this.getRoles();
    // this.getUser();
    await this.getCatalogs();
    if (this.state.idUsuario > 0) {
      this.getUser();
    } else {
      this.setState({ loadingInfo: false }, () => {
        this.renderForm(false);
      });
    }
  };
  componentWillReceiveProps = (nextProps) => {
    this.setState(
      {
        newSelected: [],
        selectcheck: false,
        Form: nextProps.form,
        reset: true,
      },
      () => {
        // this.getRoles();
        // this.getUser();
      },
    );
  };

  handleChangeDrop = (attribute, isEdit) => (evt, data) => {
    let { userInfo, showClientes, guardarDisabled, rolOperative } = this.state;
    userInfo[attribute] = data.value;
    if (attribute === "RolId") {
      userInfo.Entities = [];
      if ([1, 2].indexOf(data.value) >= 0) {
        showClientes = false;
      } else {
        showClientes = true;
      }
      if ([5].indexOf(data.value) >= 0) {
        rolOperative = true;
      } else {
        rolOperative = false;
      }

      guardarDisabled = !this.validarCampos(isEdit);
      //  else if (newSelected.length <= 0 && flatNext) {
      //   flatNext = false;
      // }
    }

    this.setState(
      { userInfo, showClientes, guardarDisabled, rolOperative },
      () => this.renderForm(isEdit),
    );
  };

  onlyUnique = (value, index, self) => {
    // eslint-disable-next-line eqeqeq
    return self.indexOf(value) === index && value != null && value !== "";
  };

  handleChangeFilter =
    (campo, isEdit) => (nextTargetKeys, direction, moveKeys) => {
      let { userInfo, guardarDisabled } = this.state;
      if (userInfo[campo]) {
        if (direction === "left") {
          moveKeys.forEach((key) => {
            var removeKey = userInfo[campo].indexOf(key);
            if (removeKey > -1) {
              userInfo[campo].splice(removeKey, 1);
            }
          });
          this.sendMessage("Retirado", "info");
        } else {
          moveKeys.forEach((key) => {
            userInfo[campo].push(key);
          });
          this.sendMessage("Agregado", "info");
        }

        userInfo[campo] = userInfo[campo].filter(this.onlyUnique);
      } else {
        this.sendMessage("Agregado", "info");
        userInfo[campo] = moveKeys;
      }
      guardarDisabled = true;
      if (
        [1, 2].indexOf(userInfo["RolId"]) >= 0 ||
        (userInfo[campo] && userInfo[campo].length > 0)
      ) {
        guardarDisabled = false;
      }

      this.setState({ userInfo, guardarDisabled });
    };

  sendMessage = (text, type) => {
    var messageClass = "";
    if (type === "error") {
      messageClass = "general-custom-ant-message error-custom-ant-message";
    } else if (type === "success") {
      messageClass = "general-custom-ant-message success-custom-ant-message";
    } else if (type === "info") {
      messageClass = "info-custom-ant-message";
    }
    message.open({
      content: text,
      className: messageClass,
    });
  };

  editarInformacionAlta = () => {
    this.setState({ showClientes: false, camposUsuario: true }, () => {
      this.renderForm(false);
    });
  };

  getUser = async () => {
    let { userInfo } = this.state;
    axios
      .get(
        `${Services.ADMIN.path}admin/getInfoUser/${this.state.idUsuario}`,
        {},
      )
      .then((response) => {
        userInfo = response.data.user[0];
        userInfo.Entities = this.parsearArrayInt(
          userInfo.EntitiesIds ? userInfo.EntitiesIds.split(",") : [],
        );

        userInfo.Branch = this.parsearArrayInt(
          userInfo.BranchCodes ? userInfo.BranchCodes.split(",") : [],
          "string",
        );

        userInfo.Reportes = this.parsearArrayInt(
          userInfo.ReportsIds ? userInfo.ReportsIds.split(",") : [],
        );
        userInfo.ReportsNames = this.obtenerNombreReportes(userInfo.Reportes);
        // tablaClientes =
        // unEditedInfo = _.cloneDeep(userInfo);
        userInfo.ConfirmPassword = "";
        userInfo.Password = "";
        this.setState(
          {
            rolOperative: [5].indexOf(userInfo.RolId) >= 0,
            userInfo,
            isEdit: true,
            tablaClientes: this.obtenerTablaClientes(userInfo.Entities),
            tablaBranch: this.obtenerTablaBranch(userInfo.Branch),
            unEditedInfo: _.cloneDeep(userInfo),
            loadingInfo: false,
          },
          () => {
            this.generarInfoGeneral();
          },
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  parsearArrayInt = (arr, type) => {
    let intArr = [];
    arr.forEach((s) => {
      if (type === "string") {
        intArr.push(s);
        return;
      }
      intArr.push(parseInt(s));
    });
    return intArr;
  };

  obtenerTablaClientes = (EntitiesIds) => {
    var arrayEntity = [];

    EntitiesIds.forEach((entId) => {
      this.state.selectCatalog["Entities"].forEach((catEnt) => {
        if (entId === catEnt.key) {
          arrayEntity.push(catEnt.data);
        }
      });
    });

    return (
      <Table
        columns={tableEntityConf}
        data={arrayEntity}
        itemsByPage={5}
        options={{
          large: true,
          downloads: {
            pdf: false,
            xlsx: false,
          },
          pagination: true,
          search: true,
        }}
      />
    );
  };

  obtenerTablaBranch = (BranchIds) => {
    var arrayBranch = [];

    BranchIds.forEach((entId) => {
      this.state.selectCatalog["Branch"].forEach((catEnt) => {
        if (entId === catEnt.key) {
          arrayBranch.push(catEnt.data);
        }
      });
    });

    return (
      <Table
        columns={tableBranchConf}
        data={arrayBranch}
        itemsByPage={5}
        options={{
          large: true,
          downloads: {
            pdf: false,
            xlsx: false,
          },
          pagination: true,
          search: true,
        }}
      />
    );
  };

  obtenerNombreReportes = (ReportsIds) => {
    let ReportsName = [];
    if (ReportsIds && ReportsIds.length > 0) {
      ReportsIds.forEach((id) => {
        this.state.selectCatalog["Reportes"].forEach((reporte) => {
          if (id === reporte.key) {
            ReportsName.push(reporte.text);
          }
        });
      });
    }
    return ReportsName;
  };

  getCatalogs = async () => {
    let { selectCatalog } = this.state;
    await axios
      .get(`${Services.ADMIN.path}admin/catalogs`, {})
      .then((response) => {
        selectCatalog["Reportes"] = response.data.reportes;
        selectCatalog["Roles"] = response.data.roles;
        selectCatalog["Entities"] = response.data.clientes;
        selectCatalog["Branch"] = response.data.branch;
        this.setState(
          {
            selectCatalog,
          },
          () => {
            this.renderForm();
          },
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  handleChange = (name, isEdit) => (event) => {
    let { userInfo, errorPass, confirmPassError, guardarDisabled } = this.state;
    userInfo[name] = event.target.value;
    if (name === "Password" || name === "ConfirmPassword") {
      const emailRegex = new RegExp(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&_-])([A-Za-z\d$@$!%*?&_-]|[^ ]){8,15}$/,
      );
      let pass = userInfo["Password"] ? userInfo["Password"] : "";
      if (emailRegex.test(pass)) {
        errorPass = false;
      } else {
        errorPass = true;
      }

      if (userInfo["ConfirmPassword"] !== userInfo["Password"]) {
        confirmPassError = true;
      } else {
        confirmPassError = false;
      }
      if (isEdit === true) {
        if (userInfo["ConfirmPassword"] === "" && userInfo["Password"] === "") {
          // eslint-disable-next-line no-use-before-define
          camposValidos = true;
          errorPass = false;
        } else {
          // eslint-disable-next-line no-use-before-define
          camposValidos = !confirmPassError && !errorPass;
        }
      } else {
        // eslint-disable-next-line no-use-before-define
        camposValidos = !confirmPassError && !errorPass;
      }
    }
    if (!confirmPassError && !errorPass) {
      var camposValidos = this.validarCampos(isEdit);
    }
    //Habilitar guardado en edicion
    if (isEdit) {
      guardarDisabled = !camposValidos;
    }

    this.setState(
      { userInfo, errorPass, camposValidos, confirmPassError, guardarDisabled },
      () => this.renderForm(isEdit),
    );
  };

  validarCampos = (isEdit) => {
    let { userInfo } = this.state;
    var campos = TemplateForm[isEdit ? "editUser" : "createUser"];
    var valido = true;
    campos.forEach((campo) => {
      if (campo.required) {
        if (!userInfo[campo.id] || userInfo[campo.id] === "") {
          valido = false;
        }
      }
    });
    var flagEntities = false;
    if (isEdit) {
      if ([1, 2].indexOf(userInfo.RolId) >= 0) {
        flagEntities = true;
      } else {
        flagEntities = userInfo.Entities && userInfo.Entities.length > 0;
      }
    } else {
      flagEntities = true;
    }

    return valido && flagEntities;
  };

  // handleChangeSelect = (selected) => (event) => {
  //   /**
  //     1-Admin
  //     2-SeaCargo SU
  //   */
  //   let { showClientes, flatNext, newSelected } = this.state;
  //   console.log("showClientes");
  //   showClientes = true;

  //   if (selected === "RolId") {
  //     if (event && [1, 2].indexOf(event.value) >= 0) {
  //       showClientes = false;
  //     } else if (newSelected.length <= 0 && flatNext) {
  //       flatNext = false;
  //     }

  //   }
  //   document.getElementById(selected).style.color = 'black';
  //   if (event && event.value) {
  //     let { user } = this.state;
  //     user[selected] = event.value;
  //     this.setState({ selected, showClientes, flatNext }, () => {
  //       this.buildFormCreate();
  //     });
  //   } else {
  //     let { user } = this.state;
  //     user[selected] = '';
  //     this.setState({ selected, showClientes, flatNext }, () => {
  //       this.buildFormCreate();
  //     });
  //   }
  // };

  recieve = (array) => {
    this.setState({
      newSelected: array,
    });
  };

  dataReport = (data, edit) => {
    let dataReport = { data: data, userId: this.props._user };

    this.setState({
      dataReport,
    });
  };
  viewPass = (isEdit) => {
    let { viewpass, TemplateForm } = this.state;
    for (
      let i = 0;
      i < TemplateForm[isEdit ? "editUser" : "createUser"].length;
      i++
    ) {
      const e = TemplateForm[isEdit ? "editUser" : "createUser"][i];
      if (e.id === "ConfirmPassword" || e.id === "Password") {
        e.datatype = viewpass ? "" : "Password";
      }
    }
    this.setState({ TemplateForm }, () => {
      this.renderForm(isEdit);
    });
  };

  /*
    ####################################GENERACION DE CAMPOS####################################
   */
  renderForm = (isEdit) => {
    let {
      TemplateForm,
      userInfo,
      selectCatalog,
      confirmPassError,
      showCatalogModal,
      viewpass,
      preview,
      errorPass,
    } = this.state;
    let createFormData = TemplateForm[isEdit ? "editUser" : "createUser"].map(
      // eslint-disable-next-line array-callback-return
      (e) => {
        if (e.type === "Input")
          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                {" "}
                <span id={e.id} style={e.style}>
                  <label>
                    {e.label}{" "}
                    {e.required === true ? (
                      <span style={{ color: "#ff0000" }}>*</span>
                    ) : (
                      ""
                    )}
                  </label>
                </span>
              </Fade>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Input
                  required
                  onFocus={(e) => {
                    e.target.setAttribute("autocomplete", "none");
                  }}
                  type={e.datatype}
                  placeholder={e.placeHolder}
                  name={e.id}
                  value={userInfo[e.id]}
                  maxlength={e.maxlength}
                  minlength={e.minlength}
                  className={e.id === "Email" ? "email-lower" : ""}
                  autoComplete="new-password"
                  // autoComplete="off"
                  onChange={this.handleChange(e.id, isEdit ? true : false)}
                  max={e.max}
                />
                {e.id === "ConfirmPassword" ? (
                  <em
                    className="mr-2 far fa-eye"
                    onClick={() =>
                      this.setState({ viewpass: !viewpass }, () =>
                        this.viewPass(isEdit),
                      )
                    }
                    style={{
                      color: "rgb(0, 121, 184)",
                      marginLeft: "10px",
                      fontSize: "20px",
                    }}
                  ></em>
                ) : (
                  ""
                )}
              </div>
              {!preview && errorPass && e.id === "Password" ? (
                <div style={{ width: "100%" }}>
                  <div
                    id="pass_diferentes"
                    style={{ marginTop: "10px", fontSize: "smaller" }}
                    className="col-12"
                  >
                    <label>
                      La contraseña debe de estar compuesta por:
                      <p style={{ color: "#BA2B30", fontSize: "smaller" }}>
                        Mínimo 8 dígitos y hasta máximo 15 dígitos. Al menos una
                        letra mayúscula y una minúscula. Un carácter especial
                        (*!$%&?).
                      </p>
                    </label>
                    {/* <ul style={{ color: '#BA2B30' }}>
                                <li>Minimun 8 digits and up to maximum 15 digits.</li>
                                <li>At least one uppercase and one lowercase letter.</li>
                                <li>A special character(*$%&?_-)</li>
                            </ul> */}
                  </div>
                </div>
              ) : (
                ""
              )}
              {!preview && confirmPassError && e.id === "ConfirmPassword" ? (
                <div style={{ width: "100%" }}>
                  <div
                    id="pass_diferentes"
                    style={{ marginTop: "10px", fontSize: "smaller" }}
                    className="col-12"
                  >
                    <label>Las contraseñas no coinciden</label>
                    {/* <ul style={{ color: '#BA2B30' }}>
                                <li>Minimun 8 digits and up to maximum 15 digits.</li>
                                <li>At least one uppercase and one lowercase letter.</li>
                                <li>A special character(*$%&?_-)</li>
                            </ul> */}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          );
        else if (e.type === "Select")
          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                <span id={e.id} style={e.style}>
                  {" "}
                  <label>
                    {e.label}{" "}
                    {e.required ? (
                      <span style={{ color: "#ff0000" }}>*</span>
                    ) : (
                      ""
                    )}{" "}
                  </label>
                </span>
              </Fade>

              <Dropdown
                className="search-drops"
                placeholder={e.label}
                id={e.id}
                options={selectCatalog[e.selectCatalogName]}
                clearable
                selection
                fluid
                allowAdditions
                value={userInfo[e.id]}
                onChange={this.handleChangeDrop(e.id, isEdit)}
              />
              <Fade left opposite>
                <label style={e.style}>{e.error}</label>
              </Fade>
            </div>
          );
        else if (e.type === "label") {
          return (
            <div className={e.class} style={{ paddingTop: "1%" }}>
              {
                <div className="row">
                  <div className={"col-md-12 col-lg-12 col-sm-6 "}>
                    <span style={{ fontWeight: "bold" }}>{e.label}</span>
                  </div>
                  <div className={"col-md-12 col-lg-12 col-sm-6 "}>
                    <span>{userInfo[e.id]}</span>
                  </div>
                </div>
              }
            </div>
          );
        } else if (e.type === "select") {
          if (userInfo[e.id]) {
            let catalog = this.state.selectCatalog[e.selectCatalogName];

            var value = catalog.filter((cat) => cat.key === userInfo[e.id]);

            return (
              <div className={e.class} style={{ paddingTop: "1%" }}>
                {
                  <div className="row">
                    <div className={"col-md-12 col-lg-12 col-sm-6 "}>
                      <span style={{ fontWeight: "bold" }}>{e.label}</span>
                    </div>
                    <div className={"col-md-12 col-lg-12 col-sm-6 "}>
                      <span>{value[0].text}</span>
                    </div>
                  </div>
                }
              </div>
            );
          }
        } else
          return (
            <div
              className={e.class}
              style={{ marginTop: "20px" }}
              key={e.id}
            ></div>
          );
      },
    );
    this.setState({
      createFormData,
      showCatalogModal,
      userInfo,
      isEdit,
    });
  };
  generarInfoGeneral = () => {
    let { userInfo, isEdit, showClientes } = this.state;
    // eslint-disable-next-line array-callback-return
    let generalInfo = TemplateForm["previewForm"].map((e) => {
      var attrInfo = "";
      var extraClass = "";

      if (e.type === "label") {
        attrInfo = <span>{userInfo[e.id]}</span>;
      } else if (e.type === "list") {
        // attrInfo = <ul>
        //     {userInfo[e.id].map(element => {
        //         return <li>{element}</li>
        //     })}
        // </ul>
        attrInfo = <span>{userInfo[e.id].length}</span>;
        extraClass = "";
      } else if (e.type === "select") {
        if (userInfo[e.id]) {
          let catalog = this.state.selectCatalog[e.selectCatalogName];

          var value = catalog.filter((cat) => cat.key === userInfo[e.id]);

          attrInfo = <span>{value[0].text}</span>;
        }
      } else if (e.type === "password") {
        if (this.state.isEdit) {
          return null;
        }
        attrInfo = <span>***********</span>;
      }
      return (
        <div className={e.class} style={{ paddingTop: "1%" }}>
          {
            <div className="row">
              <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                <span style={{ fontWeight: "bold" }}>{e.label}</span>
              </div>
              <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                {attrInfo}
              </div>
            </div>
          }
        </div>
      );
    });

    if (!isEdit) {
      showClientes = true;
    }

    this.setState({
      camposUsuario: false,
      showClientes,
      generalInfo,
      rolOperative: [5].indexOf(userInfo["RolId"]) >= 0,
    });
  };

  confirmaGuardado = async () => {
    var mensaje = "¿Estás seguro que deseas actualizar la información?";
    confirm({
      title: <hr className="hr-popover"></hr>,
      icon: false,
      cancelText: "No",
      okText: "Si",
      content: (
        <div>
          <div className="col-12" style={{ textAlign: "center" }}>
            <p class="seacargo-pop-icon">
              <em class="fas fa-exclamation-triangle"></em>
            </p>
            <span>{mensaje}</span>
          </div>
        </div>
      ),
      onOk: () => {
        this.PutUser();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  cambiaEdicion = () => {
    this.setState(
      {
        isEditing: true,
        camposUsuario: true,
      },
      () => {
        this.renderForm(true);
      },
    );
  };

  cancelarEdicion = () => {
    let { unEditedInfo } = this.state;
    this.setState(
      {
        userInfo: _.cloneDeep(unEditedInfo),
        isEditing: false,
        camposUsuario: false,
        showClientes: false,
      },
      () => {
        this.generarInfoGeneral();
      },
    );
  };

  PutUser = async () => {
    let { userInfo } = this.state;
    let data = { password: userInfo.Password };

    await axios
      .put(
        `${Services.ADMIN.path}admin/myprofile/changePass?token=${this.props._token}`,
        data,
      )
      .then((response) => {
        this.sendMessage(
          "El Usuario se ha actualizado correctamente!",
          "success",
        );
        this.setState(
          {
            isEditing: false,
            guardarDisabled: true,
          },
          () => {
            this.getUser();
          },
        );
      })
      .catch((error) => {
        this.sendMessage(error.response.data.data.message, "error");
      });
  };

  validateSaveUser = (e) => (evt) => {
    let validation = [];
    let errors = "";
    let Forms = TemplateForm.createUser;

    Forms.map((e) => {
      if (e.required === true) {
        validation.push(e);
      }
      return e;
    });
    validation.forEach((e) => {
      if (this.state.userInfo[e.id] === "") {
        errors += e.label + ", ";
        document.getElementById(e.id).style.color = "red";
      } else {
        document.getElementById(e.id).style.color = "black";
      }
    });
    if (errors.length > 0) {
      console.log("HAY ERRORES ", errors);
      message.error({
        content: "Required fields: " + errors + "",
      });
    } else {
      // if (this.state.errorPass) {
      this.generarInfoGeneral();
      // } else {
      //   message.error({
      //     content: "The Password does not conform to the specified format",
      //   });
      // }
    }
  };

  render() {
    let {
      loadingInfo,
      isEditing,
      isEdit,
      camposUsuario,
      createFormData,
      guardarDisabled,
      generalInfo,
    } = this.state;

    return loadingInfo ? (
      <Loader />
    ) : (
      <ContainerWrapper>
        <Card>
          <CardHeader>
            <div className="col-12">
              <h3>Información del usuario</h3>
              <hr className="hr-seacargo-red"></hr>
            </div>
          </CardHeader>
          <CardBody>
            <div className="col-12">
              {camposUsuario ? (
                <div>
                  <div className="row">
                    {/* <div className="col-12"> */}
                    {createFormData}

                    {/* </div> */}
                  </div>
                </div>
              ) : (
                <div>
                  <div className="row">
                    <div className="col-8">
                      <h4>{isEdit ? "" : ""}</h4>
                    </div>
                    <div className="col-4">
                      {isEdit && !isEditing ? (
                        <em
                          style={{ fontSize: "25px", marginRight: "10px" }}
                          className="fas fa-pencil-alt clickable float-right"
                          onClick={() => this.cambiaEdicion()}
                        ></em>
                      ) : (
                        false
                      )}
                    </div>
                  </div>

                  <div className="row">
                    {/* <div className="col-12"> */}
                    {generalInfo}

                    {/* </div> */}
                  </div>
                </div>
              )}
            </div>
            <div
              className="col-12 "
              style={{ marginTop: "15px", marginBottom: "15px" }}
            ></div>
            {(!this.state.camposUsuario && !isEdit) || (isEdit && isEditing) ? (
              <div
                className="col-12"
                style={{ marginTop: "15px", marginBottom: "15px" }}
              >
                <Button
                  style={{ marginLeft: "10px" }}
                  variant="contained"
                  disabled={guardarDisabled}
                  color="primary"
                  className="button float-right"
                  onClick={() => this.confirmaGuardado()}
                >
                  Guardar
                </Button>
                {isEdit && isEditing ? (
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#020e3a",
                      opacity: "80%",
                    }}
                    color="primary"
                    className="button float-right"
                    onClick={() => {
                      this.cancelarEdicion();
                    }}
                  >
                    Cancelar
                  </Button>
                ) : (
                  false
                )}
                {!isEdit ? (
                  <Button
                    variant="contained"
                    // disabled={
                    //   !this.state.siguienteEnabled ? this.state.newSelected.length <= 0 : false
                    // }
                    style={{
                      backgroundColor: "#020e3a",
                      opacity: "80%",
                    }}
                    color="secondary"
                    className="button float-right"
                    onClick={() => {
                      this.editarInformacionAlta();
                    }}
                  >
                    Atras
                  </Button>
                ) : (
                  false
                )}
              </div>
            ) : (
              <></>
            )}
          </CardBody>
        </Card>
      </ContainerWrapper>
    );
  }
}

export default withRouter(MyProfile);
